<template>
    <label :for="attributes.name || attributes.formId"
        :id="`${attributes.formId}-label`">
        <span class="field-label">
            {{attributes.label}}
            <span class="field-help" v-if="attributes.helpText">
                <span>{{attributes.helpText}}</span>
            </span>
        </span>
        <span class="field-info" v-if="!isRequired">{{attributes.optionalText}}</span>
    </label>
</template>

<script src="./vue-input-label.js"></script>
